module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ae1b1ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/callback.vue
// module id = 650
// module chunks = 1